import React from 'react';
import { useSelector } from 'react-redux';

import useFilter from '@hooks/useFilter';

import Checkbox from '@features/filter/v2/Checkbox';
import FilterName from '@features/filter/v2/FilterName';

const Characteristics = ({ filterPageName }) => {
	const { dependentFilterList } = useSelector((store) => store.dependentFilterListStore);
	const { data, handleSearch } = useFilter(filterPageName, dependentFilterList?.characteristicList);
	return (
		<>
			<FilterName type="CHARACTERISTICS" />
			<Checkbox data={data} type="CHARACTERISTICS" handleSearch={handleSearch} />
		</>
	);
};

export default Characteristics;
